import React from "react";
import PropTypes from "prop-types";

export const FeedCardHeader = ({ children = null, className = "" }) => (
  <div className={`media media--small media--internal ${className}`}>{children}</div>
);

FeedCardHeader.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};

export default FeedCardHeader;
